module.exports = __webpack_public_path__ + "static/media/sledding.c0fde14c.svg";